module.exports = __webpack_public_path__ + "static/media/25_w_main.3c392e0e.jpg";